import {Typography} from 'antd';

import {PageCard} from '../../../../../../layout/page-card/page-card';
import {Locale} from '../../../../../../provider/locale/locale';
import {
    AiMonitoringRunType,
    AiMonitoringScorePointType,
} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';
import {AnswersFeed} from '../answers-feed/answers-feed';
import {OverviewBlock} from '../overview/overview-block';
import {ScoreDynamicsChart} from '../score-dynamics-chart/score-dynamics-chart';

import * as styles from './prompt-mentions-tab.scss';

type PropsType = {
    brandId: number;
    run: AiMonitoringRunType;
    currentRunId: string | null;
    series: Array<AiMonitoringScorePointType>;
    competitorIds: Array<number>;
};

export function PromptMentionsTab(props: PropsType): JSX.Element {
    const {brandId, run, currentRunId, series, competitorIds} = props;

    return (
        <>
            <PageCard>
                <Typography.Paragraph className={styles.prompt_mentions_tab__intro} type="secondary">
                    <Locale stringKey="AI_BRAND_MONITORING__PROMPTS__INTRO" />
                </Typography.Paragraph>
            </PageCard>

            <PageCard>
                <OverviewBlock run={run} />
            </PageCard>

            <PageCard>
                <ScoreDynamicsChart competitorIds={competitorIds} series={series} />
            </PageCard>

            <PageCard>
                <AnswersFeed brandId={brandId} runId={currentRunId} />
            </PageCard>
        </>
    );
}
